import { render, staticRenderFns } from "./WelcomePopupV3.vue?vue&type=template&id=fd4c61a6&scoped=true&"
import script from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
export * from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePopupV3.vue?vue&type=style&index=0&id=fd4c61a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4c61a6",
  null
  
)

export default component.exports